import React from 'react'
import './App.css';
import ManagePage from './containers/ManagePageContainer'
import ManageShellCard from './containers/ManageShellCardContainer'
import ManageVehicleGroups from './containers/ManageVehicleGroupsContainer'
import Home from './Pages/Home'
import LoginNew from './containers/LoginContainer'
import Administration from './Pages/Administration'
import EventAndReports from './Pages/EventAndReports'
import ManageDriverSchedule from './Pages/ManageDriverSchedule'
import { ProtectedRoute } from './components/protected-route'
import UpdateUserProfile from './Pages/UpdateUserProfile'
import ManageHSSE from './containers/ManageHSSEContainer'
import AccountSelection from './containers/AccountSelectionContainer'
import CustomFooter from './containers/FooterContainer'
import CustomHeader from './containers/HeaderContainer'
import TestStepper from './containers/TestStepperContainer'
import BasicTable from './components/Tables/BasicTable'
import FleetOverviewGraph from './Pages/Charts/FleetOverviewGraph'
import SuspiciousTransactionsGraph from './Pages/Charts/SuspiciousTransactionsGraph'
import HSSEEventsGraph from './Pages/Charts/HSSEEventsGraph'
import ManageDeclinedTransaction from './containers/ManageDeclinedTransactionContainer'
import GraphsSection from './Pages/GraphsSection';
import Finance from './containers/FinanceContainer'
import MyReports from './containers/MyReportsContainer'
import VehicleManagement from './containers/VehicleManagementContainer'
import ManualTransaction from './containers/ManualTransactionContainer'
import AddNewUser from './Pages/AddNewUser'
import UpdatePassword from './Pages/UpdatePassword'
import SetPassword from './Pages/SetPassword'
import auth from './auth'
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect
} from "react-router-dom";
import ActivityLog from './containers/ActivityLogContainer';
import Notifications from './Pages/Notifications';
import MyFlaggedEvents from './Pages/MyFlaggedEvents';
import axiosConfig from './config/axiosConfig';

import ManageVehicleHealth from './Pages/ManageVehicleHealth'
import ManualOrAdjustedTransaction from './Pages/ManualOrAdjustedTransaction'
import AddOrDeleteAdjustedTransaction from './Pages/AddOrDeleteAdjustedTransaction'
import EditOrDeleteManualTransaction from './Pages/EditOrDeleteManualTransaction'
import AdjustTransaction from './containers/AdjustTransactionContainer'
import EditManualTransaction from './containers/EditManualTransactionContainer'
import ViewOrDeleteAdjustedTransaction from './containers/ViewOrDeleteAdjustedTransactionContainer'
import MyReminderActivity from './containers/MyReminderActivityContainer'

import MaintenanceLog from './containers/MaintenanceLogContainer'

import AdhocActivity from './containers/AdhocMaintenanceContainer'

import TrackerReport from './containers/TrackerReportContainer'

import ManageReports from './Pages/ManageReports'
import TrendReports from './containers/TrendReportsContainer'
import GeneralReports from './containers/GeneralReportsContainer'
import SuspiciousReports from './containers/SuspiciousReportsContainer'

import FeedbackContainer from './containers/FeedbackContainer'

import FleetOverviewSelection from './Pages/Charts/FleetOverViewSelection'

import FleetOverViewDashboardSummary from './Pages/Charts/FleetOverViewDashboardSummary'
import FleetOverViewBulletIn from './Pages/Charts/FleetOverViewBulletIn'
import FleetOverViewAnalysis from './Pages/Charts/FleetOverViewAnalysis'
import FleetOverViewFleetSummary from './Pages/Charts/FleetOverViewFleetSummary'

import HSSEEventSelection from './Pages/Charts/HSSEEventSelection'
import HSSEDashboardSummary from './Pages/Charts/HSSEDashboardSummary'
import HSSEBulletIn from './Pages/Charts/HSSEBulletIn'
import HSSEAnalysis from './Pages/Charts/HSSEAnalysis'
import HSSEFleetSummary from './Pages/Charts/HSSEFleetSummary'


import SuspiciousSelection from './Pages/Charts/SuspiciousSelection'
import SuspiciousDashboardSummary from './Pages/Charts/SuspiciousDashboardSummary'
import SuspiciousFleetBulletIn from './Pages/Charts/SuspiciousFleetBulletIn'
import SuspiciousFleetAnalysis from './Pages/Charts/SuspiciousFleetAnalysis'
import SuspiciousFleetSummary from './Pages/Charts/SuspiciousFleetSummary'
import ManageSusTransSub from './Pages/ManageSusTransSub';
import TestParentComponent from './Pages/TestParentComponent';
import ViewSuspTransSummary from './Pages/ViewSuspTransSummary';

import AddBulkTransaction from './containers/AddBulkTransactionContainer'
import {useEffect,useRef} from 'react';




function App(props) {
  

  if (props.data.userID === '' && localStorage.getItem('userid') !== null) {
    (async function () {

      let [userBranches, selectedBranchID, selectedBranchNumber, selectedBranchName] = await Promise.all([JSON.parse(localStorage.getItem('UserBranches')), localStorage.getItem('selectedBranch'), localStorage.getItem('selectedBranchNumber'), localStorage.getItem('selectedBranchName')]);
      props.getUserBranchesHandler(userBranches[0]._BranchDetail)

    })();
    if (localStorage.getItem('userid') !== '') {
      axiosConfig.defaults.headers.common['Token'] = localStorage.getItem('token');
      props.LoginHandler({ token: localStorage.getItem('token'), userID: localStorage.getItem('userid') })
      props.setCardFeeHandler({ TotalFee: parseInt(localStorage.getItem('TotalFee')), IncrementalFee: parseInt(localStorage.getItem('IncrementalFee')) })
      props.selectBranchHandler({ id: localStorage.getItem('selectedBranch'), Number: localStorage.getItem('selectedBranchNumber'), Name: localStorage.getItem('selectedBranchName') })
    }
    localStorage.setItem('tabClosed', 'true');
    
  }

  
  useEffect(() => {
    const handleBeforeUnload = (event) => {
      debugger
      event.preventDefault();

      if (localStorage.getItem('tabClosed') === 'true' || localStorage.getItem('tabClosed') === null) {
      // Display a confirmation message to the user
     
      console.log('i am not hidden and close tab change')
      return event.returnValue = 'Are you sure you want to leave? Your unsaved changes may be lost.';
      
      // Perform your logout action here, such as clearing authentication tokens or logging out the user on the server
      // You should replace this with your actual logout logic
      
      // For example, you can clear a token from local storage
      // localStorage.removeItem('authToken');
       }
      };

       const handleUnload = (event) => {
       event.preventDefault();
       // This code will run just before the page is unloaded
      // You can perform cleanup actions here
      console.log('Page is being unloaded');
      if (localStorage.getItem('tabClosed') === 'true' || localStorage.getItem('tabClosed') === null) {
      localStorage.clear();
      // localStorage.setItem('tabClosed', 'true');
      }
      else
        {
          localStorage.setItem('tabClosed','true');
        }


       };

             



      

    

    
    debugger

    // window.addEventListener('beforeunload', handleBeforeUnload);
    // window.addEventListener('unload', handleUnload); 

    
    return () => {
      // window.removeEventListener('beforeunload', handleBeforeUnload);
      // window.removeEventListener('unload',handleUnload); 
      // //   // Note that any code here should be fast and non-blocking,
        // as the page unloads immediately after this event.
    
      
  
    };
  }, []);

 
  



  return (

    <Router basename="/telematicsportal">
      document.title = "Shell Telematics"

      <div className="App containercustom" style={{ overflowX: 'auto', fontSize: '14px' }}>
        <div className="bodycontainer">


          {auth.isAuthenticated() && <CustomHeader ></CustomHeader>}

          <Switch>
            <Route exact path="/Login" component={LoginNew} />
            <div style={{ paddingTop: '130px' }}>
              <Route exact path="/SetPassword" component={SetPassword} />

              <ProtectedRoute exact path="/" component={Home} />

              <ProtectedRoute exact path="/ViewSuspTransSummary" component={ViewSuspTransSummary} />
              <ProtectedRoute exact path="/AccountSelection" component={AccountSelection} />
              <ProtectedRoute exact path="/Manage" component={ManagePage} />
              <ProtectedRoute exact path="/Administration" component={Administration} />
              <ProtectedRoute exact path="/EventAndReports" component={EventAndReports} />
              <ProtectedRoute exact path="/ManageShellCard" component={ManageShellCard} />
              <ProtectedRoute exact path="/ManageDriverSchedule" component={ManageDriverSchedule} />
              <ProtectedRoute exact path="/ManageDeclinedTransaction" component={ManageDeclinedTransaction} />
              <ProtectedRoute exact path="/ManageVehicleGroups" component={ManageVehicleGroups} />
              <ProtectedRoute exact path="/UpdateUserProfile" component={UpdateUserProfile} />
              <ProtectedRoute exact path="/ManageHSSE" component={ManageHSSE} />
              <ProtectedRoute exact path="/GraphsSection" component={GraphsSection} />
              <ProtectedRoute exact path="/FleetOverviewGraph" component={FleetOverviewGraph} />
              <ProtectedRoute exact path="/SuspiciousTransactionsGraph" component={SuspiciousTransactionsGraph} />
              <ProtectedRoute exact path="/HSSEEventsGraph" component={HSSEEventsGraph} />
              <ProtectedRoute exact path="/ManageSuspiciousTransaction" component={TestStepper} />
              <ProtectedRoute exact path="/MyReports" component={ManageReports} />
              <ProtectedRoute exact path="/BasicTable" component={BasicTable} />
              <ProtectedRoute exact path="/Finance" component={Finance} />
              <ProtectedRoute exact path="/VehicleManagement" component={VehicleManagement} />
              <ProtectedRoute exact path="/AddNewUser" component={AddNewUser} />
              <ProtectedRoute exact path="/UpdatePassword" component={UpdatePassword} />
              <ProtectedRoute exact path="/ActivityLog" component={ActivityLog} />
              <ProtectedRoute exact path="/Notifications" component={Notifications} />
              <ProtectedRoute exact path="/MyFlaggedEvents" component={MyFlaggedEvents} />
              {/* <ProtectedRoute exact path="/SetPassword" component={SetPassword} /> */}
              <ProtectedRoute exact path="/ManageVehicleHealth" component={ManageVehicleHealth} />
              <ProtectedRoute exact path="/ManualOrAdjustedTransaction" component={ManualOrAdjustedTransaction}/>
              <ProtectedRoute exact path="/AddOrDeleteAdjustedTransaction" component={AddOrDeleteAdjustedTransaction}/>
              <ProtectedRoute exact path="/EditOrDeleteManualTransaction" component={EditOrDeleteManualTransaction}/>
              <ProtectedRoute exact path="/ManualTransaction" component={ManualTransaction}/>
              <ProtectedRoute exact path="/AdjustTransaction" component={AdjustTransaction} />
              <ProtectedRoute exact path="/EditManualTransaction" component={EditManualTransaction} />
              <ProtectedRoute exact path="/ViewOrDeleteAdjustedTransaction" component={ViewOrDeleteAdjustedTransaction} />
              <ProtectedRoute exact path="/MyReminderActivity" component={MyReminderActivity} />
              <ProtectedRoute exact path="/MaintenanceLog" component={MaintenanceLog} />
              <ProtectedRoute exact path="/AdhocActivity" component={AdhocActivity} />

              <ProtectedRoute exact path="/ManageReports" component={ManageReports} />
              <ProtectedRoute exact path="/TrendReports" component={TrendReports} />
              <ProtectedRoute exact path="/GeneralReports" component={GeneralReports} />
              <ProtectedRoute exact path="/SuspiciousReports" component={SuspiciousReports} />

              <ProtectedRoute exact path="/FeedbackContainer" component={FeedbackContainer} />

              <ProtectedRoute exact path="/FleetOverviewSelection" component={FleetOverviewSelection} />
              <ProtectedRoute exact path="/FleetOverViewDashboardSummary" component={FleetOverViewDashboardSummary} />
              <ProtectedRoute exact path="/FleetOverViewBulletIn" component={FleetOverViewBulletIn} />
              <ProtectedRoute exact path="/FleetOverViewAnalysis" component={FleetOverViewAnalysis} />
              <ProtectedRoute exact path="/FleetOverViewFleetSummary" component={FleetOverViewFleetSummary} />

              <ProtectedRoute exact path="/HSSEEventSelection" component={HSSEEventSelection} />
              <ProtectedRoute exact path="/HSSEDashboardSummary" component={HSSEDashboardSummary} />
              <ProtectedRoute exact path="/HSSEBulletIn" component={HSSEBulletIn} />
              <ProtectedRoute exact path="/HSSEAnalysis" component={HSSEAnalysis} />
              <ProtectedRoute exact path="/HSSEFleetSummary" component={HSSEFleetSummary} />


              <ProtectedRoute exact path="/SuspiciousSelection" component={SuspiciousSelection} />
              <ProtectedRoute exact path="/SuspiciousDashboardSummary" component={SuspiciousDashboardSummary} />
              <ProtectedRoute exact path="/SuspiciousFleetBulletIn" component={SuspiciousFleetBulletIn} />
              <ProtectedRoute exact path="/SuspiciousFleetSummary" component={SuspiciousFleetSummary} />
              <ProtectedRoute exact path="/SuspiciousFleetAnalysis" component={SuspiciousFleetAnalysis} />


              <ProtectedRoute exact path="/TrackerReport" component={TrackerReport} />

              <ProtectedRoute exact path="/AddBulkTransaction" component={AddBulkTransaction} />
              <ProtectedRoute exact path="/ManageSusTransSub" component={ManageSusTransSub} />
              <ProtectedRoute exact path="/TestParentComponent" component={TestParentComponent} />
              </div>
              <Redirect to="/404" />
            
          </Switch>

        </div>
        {auth.isAuthenticated() && <CustomFooter></CustomFooter>}
      </div>
    </Router>
  );
}
export default App;
